import { Component, OnInit } from '@angular/core';
import { TicketViewModel } from 'libs/core/src/lib/model/view-model/shared/ticket/ticket.view.model';
import { BasketListComponent } from 'libs/shared/src/lib/component/basket/basket-list/basket-list.component';

@Component({ standalone: false, selector: 'app-basket-list', templateUrl: './basket-list.component.html' })
export class CustomBasketListComponent extends BasketListComponent implements OnInit {
  public rebuildOptionalTickets(orderTickets: TicketViewModel[]) {}
  public afterOrderStateChanged() {}
}
